import AppStoreContext from 'contexts/AppStoreContext';
import { Collection, List } from 'immutable';
import React, { FC, useContext, useEffect, useState } from 'react';
import { Markup } from 'records/Markup';
import { RFI } from 'records/RFI';
import { getMarkupsFromRFIIDs } from 'utils/queryRFIs';
import RFIListHeader from './RFIListHeader';
import RFIListRow from './RFIListRow';

type Props = {
  onRFIListRowClick: (rfi: RFI, markup: Markup) => Promise<void>;
};

interface RFIMarkup {
  rfi: RFI;
  markup: Markup;
}

const RFIList: FC<Props> = ({ onRFIListRowClick }) => {
  const { state: appState } = useContext(AppStoreContext);
  const { rfis, markups, rfiQuery, queriedRFIs } = appState;
  const project = appState.getProject();
  const [markupsList, setMarkupsList] = useState<
    List<Collection<number, RFIMarkup>>
  >(List());

  useEffect(() => {
    const markupsOnVisiblePages = markups.filter((_, pageId) =>
      rfiQuery?.pages?.has(pageId)
    );

    const markupsOnVisiblePagesForQueriedRfis = getMarkupsFromRFIIDs(
      rfis,
      markupsOnVisiblePages,
      queriedRFIs
    );

    const markupsGroupedByRfiBaseId = markupsOnVisiblePagesForQueriedRfis
      .groupBy((item) => item.rfi.get('id').split('+'))
      .toList();

    setMarkupsList(markupsGroupedByRfiBaseId);
  }, [rfiQuery]);

  return (
    <div className="bgd-white grow-1">
      <RFIListHeader count={markupsList.size} />
      <div style={{ height: 'calc(100vh - 248px' }} className="oa">
        {markupsList.map((rfiMarkups) => {
          const currentMarkup: RFIMarkup = rfiMarkups.first();

          //remove the older version of Rfi from the list
          if (
            markupsList.size > 1 &&
            !currentMarkup.rfi.previousversionid &&
            currentMarkup.rfi.nextversionid
          ) {
            return null;
          }

          return (
            <RFIListRow
              key={currentMarkup.markup.markupid}
              project={project}
              rfi={currentMarkup.rfi}
              markup={currentMarkup.markup}
              onRFIListRowClick={onRFIListRowClick}
            />
          );
        })}
      </div>
    </div>
  );
};

export default RFIList;
